'use client';

/**
 * Notification Service Hook
 * 
 * Initializes the notification service with API configuration and authentication.
 */

import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '@/app/store';
import { notificationService } from '../services/notificationService';
import { API_BASE_URL } from '@/app/constants/apiConstants';
import { tokenManager } from '@/app/services/auth/tokenManager';

export const useNotificationService = () => {
  const isAuthenticated = useSelector((state: RootState) => state.auth.isAuthenticated);

  useEffect(() => {
    // Initialize notification service with configuration
    notificationService.initialize({
      baseURL: API_BASE_URL,
      getAccessToken: () => {
        // Use tokenManager for centralized token access
        if (typeof window === 'undefined') return null;
        const tokens = tokenManager.getTokens();
        return tokens?.accessToken || null;
      },
    });
  }, [isAuthenticated]); // Re-initialize when authentication state changes
};
